import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux'
import useAlert from '@hooks/useAlert'
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Grid,
  Box,
  Typography,
  Container,
  useTheme,
  IconButton,
} from '@mui/material/'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import styled from 'styled-components'
import WebService from '../util/webService'
import useSnackbar from '../hooks/useSnackbar'
import { setAccount } from '../redux/actions/accountAction'
import { isAdmin, isStringNullOrEmpty } from '../util/helper'
import useIndicator from '@hooks/useIndicator'
import { isExpired, decodeToken } from 'react-jwt'
import logo from '@images/logo.png'
import { showSnackbar } from '@context/SnackbarContext'
import { emailRegex, nameRegex, passwordRegex } from '@util/helper'
import NumericTextField from '@components/NumericTextField'
import { useLocation } from 'react-router-dom'
import { ArrowBackOutlined } from '@mui/icons-material'
import { siteTitle } from '@util/string'
// mui의 css 우선순위가 높기때문에 important를 설정 - 실무하다 보면 종종 발생 우선순위 문제
const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`

//
const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`

const Login = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { alert, renderAlert } = useAlert()
  const buttonRef = useRef(null)
  const location = useLocation()
  const doc = location.state?.doc ?? {}
  const pack = location?.state?.pack
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      buttonRef.current.click()
    }
  }

  const onSuccess = (resp) => {
    const repMessage = JSON.parse(resp.repMessage)
    console.log('long suc =>', repMessage)
    const account = JSON.parse(repMessage.account)
    dispatch(setAccount(account))

    const token = repMessage.token
    const decoded = decodeToken(token)

    const accessToken = repMessage.accessToken
    localStorage.setItem('accessToken', accessToken)

    const refreshToken = repMessage.refreshToken
    localStorage.setItem('refreshToken', refreshToken)

    const deviceId = repMessage.deviceId
    localStorage.setItem('deviceId', deviceId)

    if (pack?.furl) {
      navigate(pack.furl, {
        replace: true,
        state: {
          docs: [doc],
        },
      })
    } else {
      navigate('/admin')
    }
  }

  const MemberLogin = () => {
    const [loginId, set_loginId] = useState('')
    const [password, set_password] = useState('')

    const canLogin = () => {
      return loginId && password
    }
    const onLogin = async () => {
      const url = '/login'
      if (!loginId || !password) {
        showSnackbar('아이디 또는 패스워드를 입력하세요.')
        return
      }
      const data = { loginId: loginId, password: password }

      const resp = await WebService.post(url, data)

      if (resp.repCode !== 'ack') {
        alert(resp.repMessage)
        return
      }

      onSuccess(resp)
    }

    useEffect(() => {
      document.addEventListener('keydown', handleKeyPress)
      return () => {
        document.removeEventListener('keydown', handleKeyPress)
      }
    }, [])
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              required
              autoFocus
              fullWidth
              type='text'
              id='loginId'
              name='loginId'
              label='이메일'
              size='md'
              onChange={(e) => {
                set_loginId(e.target.value)
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              type='password'
              id='password'
              name='password'
              label='패스워드'
              size='md'
              onChange={(e) => {
                set_password(e.target.value)
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              ref={buttonRef}
              variant='contained'
              size='large'
              disabled={!canLogin()}
              onClick={() => onLogin()}
            >
              로그인
            </Button>
          </Grid>
        </Grid>
      </>
    )
  }


  return (
    <>
      <Container component='main' maxWidth='sm'>
        <CssBaseline />
        <Grid container spacing={5} style={{ marginTop: 50 }}>
          <Grid item xs={12}>
            <IconButton
              onClick={() => {
                const pack = location.state?.pack ?? {}
                if (pack?.burl) {
                  navigate(pack.burl, {
                    replace: true,
                    state: {
                      pack: pack,
                    },
                  })
                }
                else {
                  navigate('/admin')
                }
              }}
            >
            </IconButton>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='h4' style={{ fontWeight: 'bold', textAlign: 'center' }}>
              {siteTitle} 로그인
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <MemberLogin />
          </Grid>
        </Grid>
      </Container>
      {renderAlert()}
    </>
  )
}

export default Login
